import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { HlmButton } from '@spartan-ng/helm/button';
import { ThemedIconComponent } from '../themed-icon/themed-icon.component';

@Component({
  selector: 'ocp-open-in-browser-button',
  template: `
    <button
      type="button"
      hlmBtn
      variant="ghost"
      size="icon"
      class="open-in-browser-button"
      (click)="clicked.emit()"
      [attr.aria-label]="'common.open-in-browser' | translate"
    >
      <ocp-themed-icon name="open-in-new.svg" [size]="18" />
    </button>
  `,
  styleUrl: './open-in-browser-button.component.scss',
  imports: [TranslatePipe, HlmButton, ThemedIconComponent],
})
export class OpenInBrowserButtonComponent {
  readonly clicked = output<void>();
}
